import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import Input from '@/components/Input/Input'
import Label from '@/components/Label'
import Loading from '@/components/Loading'
import { useAllEducationLevels } from '@/queries/useAllEducationLevels'

import styles from './FullNamePreview.module.scss'
import type { CourseFormPayload } from '../constants/course-payload'
import { getFullNamePreview } from '../utils/get-full-name-preview'

const FullNamePreview = () => {
  const { t } = useTranslation('coursesManagement')

  const { data: allEducationLevels, isLoading } = useAllEducationLevels()
  const fullNamePreviewId = 'preview-name'

  const { watch } = useFormContext<CourseFormPayload>()

  const name = watch('name')
  const selectedEducationLevelId = watch('educationLevel')

  const educationLevel =
    allEducationLevels?.map?.[selectedEducationLevelId]?.shortName

  const fullName = getFullNamePreview({
    name,
    educationLevel
  })

  return (
    <div className={styles.container}>
      <Label id={fullNamePreviewId} label={t('label.full-name-preview')} />
      <Loading spinning={isLoading}>
        <Input disabled id={fullNamePreviewId} value={fullName} />
      </Loading>
    </div>
  )
}

export default FullNamePreview
